// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Landing post-checkout de Troly Premium. Tokens --troly-* (styles/tokens.css). */

.premium-success {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.premium-success__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  max-width: 440px;
  width: 100%;
  padding: 44px 32px;
  background: var(--troly-bg-elevated);
  border: 1px solid var(--troly-border);
  border-radius: var(--troly-radius-lg);
}

.premium-success__badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: var(--troly-radius-pill);
  background: var(--troly-action);
  color: var(--troly-action-ink);
}

.premium-success__eyebrow {
  font-family: var(--troly-font-body);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--troly-accent);
}

.premium-success__title {
  font-family: var(--troly-font-display);
  font-size: 1.7rem;
  font-weight: 600;
  color: var(--troly-fg);
  margin: 0;
}

.premium-success__text {
  font-family: var(--troly-font-body);
  font-size: 0.95rem;
  color: var(--troly-fg-muted);
  margin: 0;
  line-height: 1.55;
}

.premium-success__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  padding: 13px 28px;
  border-radius: var(--troly-radius-md);
  font-family: var(--troly-font-body);
  font-size: 14px;
  font-weight: 600;
  background: var(--troly-action);
  color: var(--troly-action-ink);
  border: 1px solid var(--troly-action);
  transition: opacity 0.18s, transform 0.12s;
}

.premium-success__cta:hover { opacity: 0.88; transform: translateY(-1px); }

.premium-success__cta--ghost {
  background: transparent;
  color: var(--troly-fg);
  border-color: var(--troly-border-strong);
}

.premium-success__cta:focus-visible {
  outline: 2px solid var(--troly-action);
  outline-offset: 2px;
}

.premium-success__spinner {
  width: 36px;
  height: 36px;
  border-radius: var(--troly-radius-pill);
  border: 3px solid var(--troly-border);
  border-top-color: var(--troly-action);
  animation: premium-success-spin 0.8s linear infinite;
}

@keyframes premium-success-spin {
  to { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
  .premium-success__spinner { animation-duration: 2s; }
  .premium-success__cta:hover { transform: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PremiumSuccess.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA,8BAA8B,aAAa,EAAE,2BAA2B,EAAE;;AAE1E;EACE,uBAAuB;EACvB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,qCAAqC;EACrC,qCAAqC;EACrC,oDAAoD;AACtD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,4BAA4B,sBAAsB,EAAE;EACpD,8BAA8B,eAAe,EAAE;AACjD","sourcesContent":["/* Landing post-checkout de Troly Premium. Tokens --troly-* (styles/tokens.css). */\n\n.premium-success {\n  min-height: calc(100vh - 120px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n}\n\n.premium-success__card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 14px;\n  max-width: 440px;\n  width: 100%;\n  padding: 44px 32px;\n  background: var(--troly-bg-elevated);\n  border: 1px solid var(--troly-border);\n  border-radius: var(--troly-radius-lg);\n}\n\n.premium-success__badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: var(--troly-radius-pill);\n  background: var(--troly-action);\n  color: var(--troly-action-ink);\n}\n\n.premium-success__eyebrow {\n  font-family: var(--troly-font-body);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--troly-accent);\n}\n\n.premium-success__title {\n  font-family: var(--troly-font-display);\n  font-size: 1.7rem;\n  font-weight: 600;\n  color: var(--troly-fg);\n  margin: 0;\n}\n\n.premium-success__text {\n  font-family: var(--troly-font-body);\n  font-size: 0.95rem;\n  color: var(--troly-fg-muted);\n  margin: 0;\n  line-height: 1.55;\n}\n\n.premium-success__cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 8px;\n  padding: 13px 28px;\n  border-radius: var(--troly-radius-md);\n  font-family: var(--troly-font-body);\n  font-size: 14px;\n  font-weight: 600;\n  background: var(--troly-action);\n  color: var(--troly-action-ink);\n  border: 1px solid var(--troly-action);\n  transition: opacity 0.18s, transform 0.12s;\n}\n\n.premium-success__cta:hover { opacity: 0.88; transform: translateY(-1px); }\n\n.premium-success__cta--ghost {\n  background: transparent;\n  color: var(--troly-fg);\n  border-color: var(--troly-border-strong);\n}\n\n.premium-success__cta:focus-visible {\n  outline: 2px solid var(--troly-action);\n  outline-offset: 2px;\n}\n\n.premium-success__spinner {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--troly-radius-pill);\n  border: 3px solid var(--troly-border);\n  border-top-color: var(--troly-action);\n  animation: premium-success-spin 0.8s linear infinite;\n}\n\n@keyframes premium-success-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .premium-success__spinner { animation-duration: 2s; }\n  .premium-success__cta:hover { transform: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
